import _ from 'underscore';
import SystemDialogService from '../../../../shared/services/systemDialogService.js';
import stammdatenService from '../services/stammdatenService.js';
import systemNachrichtService from '../services/systemNachrichtService.js';
import { collectValues, displayArray, displayValues, fuelleSelectOptionen } from '../util.js';
import { updateDebounceUnternehmen } from './verwaltung.js';
import { MitarbeiterAppInstallationEmail } from '../../../../../domain/konstanten/EmailTemplates.js';

window.myHandlers = window.myHandlers || {};
window.myHandlers.speichereAppEinstellungen = speichereAppEinstellungen;
window.myHandlers.speichereCronjobEinstellungen = speichereCronjobEinstellungen;
window.myHandlers.speichereUnternehmenStandards = speichereUnternehmenStandards;
window.myHandlers.clickNeuesVerzeichnis = clickNeuesVerzeichnis;
window.myHandlers.confirmNeuesVerzeichnisDialog = confirmNeuesVerzeichnisDialog;
window.myHandlers.speicherePostfachVerzeichnisse = speicherePostfachVerzeichnisse;
window.myHandlers.clickEntferneVerzeichnis = clickEntferneVerzeichnis;
window.myHandlers.freigabeVerzeichnis = freigabeVerzeichnis;
window.myHandlers.editWillkommensEmail = editWillkommensEmail;
window.myHandlers.confirmWillkommensEmail = confirmWillkommensEmail;
window.myHandlers.resetWillkommensEmail = resetWillkommensEmail;
window.myHandlers.uploadWillkommensAnhaenge = uploadWillkommensAnhaenge;
window.myHandlers.editEmailAbsenderName = editEmailAbsenderName;
window.myHandlers.confirmEmailAbsenderName = confirmEmailAbsenderName;

/**
 * lädt/speichert die Einstellungen der Apps
 */
async function ladeAppEinstellungen() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-app');
	displayValues(unternehmen.MitarbeiterAppEinstellungen, '', panelEinstellungen, 'u-');
}

async function speichereAppEinstellungen() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-app');
	collectValues(unternehmen.MitarbeiterAppEinstellungen, 'u-', panelEinstellungen);
	updateDebounceUnternehmen(unternehmen);
}

async function ladeCronjobEinstellungen() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-cronjob');
	displayValues(unternehmen.NeolohnEinstellungen, '', panelEinstellungen, 'u-Cronjob-');
}

async function speichereCronjobEinstellungen() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-cronjob');
	collectValues(unternehmen.NeolohnEinstellungen, 'u-Cronjob-', panelEinstellungen);
	updateDebounceUnternehmen(unternehmen);
}

/**
 * Funktionen/Event Handlers für die Verzeichnisverwaltung
 */
async function ladePostfachVerzeichnisse() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-verzeichnisse');
	// Clean up old html (happens when adding new verzeichnis)
	const postfaecherHTML = document.querySelectorAll('.u-verzeichnis-zeile[id]');
	[...postfaecherHTML].forEach((postfach) => postfach.remove());


	// Wir zeigen hier nur die zusätzlichen Verzeichnisse an
	displayArray(unternehmen.Verzeichnisse.filter((vz) => vz.SystemVerzeichnis && vz.VerzeichnisName !== 'Papierkorb'), 'u-system-verzeichnis-', panelEinstellungen);
	// Wir zeigen hier nur die zusätzlichen Verzeichnisse an
	displayArray(unternehmen.Verzeichnisse.filter((vz) => !vz.SystemVerzeichnis), 'u-zusatz-verzeichnis-', panelEinstellungen);
}

async function speicherePostfachVerzeichnisse() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-verzeichnisse');
	// Verzeichnisse speichern
	unternehmen.Verzeichnisse.forEach((verzeichnis) => {
		if (!verzeichnis.SystemVerzeichnis) {
			// wir suchen die VerzeichnisID im Frontend und die zugehörigen Inputfelder.
			const zeile = panelEinstellungen.querySelector(`[aria-label="${verzeichnis._id}"]`);
			const zeileVerzeichnisName = zeile.querySelector('[aria-label="u-zusatz-verzeichnis-VerzeichnisName"]').value;
			// einen leeren String wollen wir nicht als Namen haben
			verzeichnis.VerzeichnisName = zeileVerzeichnisName === '' ? verzeichnis.VerzeichnisName : zeileVerzeichnisName;
		}
	});
	updateDebounceUnternehmen(unternehmen);
}

async function clickNeuesVerzeichnis() {
	const input = await SystemDialogService.instance.displayAsync('neu-verzeichnis-dialog');
	if (input.success) {
		const result = await stammdatenService.erstellePostfachVerzeichnis(input.data);
		if (result) {
			await ladePostfachVerzeichnisse();
		}
	}
}

async function confirmNeuesVerzeichnisDialog() {
	const verzeichnisName = document.getElementById('neu-verzeichnis-name').value;
	SystemDialogService.instance.confirm(verzeichnisName);
}

async function clickEntferneVerzeichnis(thisElement) {
	const verzeichnisID = thisElement.parentNode.getAttribute('aria-label');
	const result = await stammdatenService.entfernePostfachVerzeichnis(verzeichnisID);
	if (result) {
		await ladePostfachVerzeichnisse();
	}
}

async function ladeMitarbeiterStandards() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-standard');
	const select = panelEinstellungen.querySelector('[aria-label="u-standard-PausenmodellStandard"]');
	fuelleSelectOptionen(select, unternehmen.Pausenmodelle, '_id', 'Bezeichnung', true, 'keins');
	displayValues(
		_.pick(unternehmen, [
			'SFNKappen',
			'SFNMindestlohnrelevant',
			'SFNAusgleichsbetragSVpflichtig',
			'SFNSteuerSVFreiSplit',
			'N6ZuschlagZusatz',
			'GutzeitAutomatisierung',
			'AutomatischeProbezeitBis',
			'AutomatischeBefristungBis',
			'PausenmodellStandard',
			'UrlaubAmFeiertag', 
			'ZeiterfassungNurMitDienstplan',
			'BerechnungEntgeltfortzahlung',
			'ArbeitAmFeiertag',
			'BetriebsbezogenePersonalnummern'
		]),
		'',
		panelEinstellungen,
		'u-standard-'
	);
}

async function speichereUnternehmenStandards() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const panelEinstellungen = document.getElementById('u-standard');
	collectValues(unternehmen, 'u-standard-', panelEinstellungen);
	updateDebounceUnternehmen(unternehmen);
}
async function ladeAlleEinstellungen() {
	await ladeAppEinstellungen();
	await ladeCronjobEinstellungen();
	await ladePostfachVerzeichnisse();
	await ladeMitarbeiterStandards();
	await ladeWillkommensAnhaenge();
	await ladeEmailEinstellungen();
}

/**
 * Zeigt den hinterlegten Absendernamen an, ohne Eingabe den vordefinierten Standard.
 */
async function ladeEmailEinstellungen() {
	const anzeige = document.getElementById('u-email-absender-anzeige');
	if (!anzeige) {
		return;
	}
	const einstellungen = await stammdatenService.getEmailAbsenderName();
	const istStandard = _.isEmpty(einstellungen.AbsenderName);
	anzeige.innerText = istStandard ? einstellungen.StandardAbsenderName : einstellungen.AbsenderName;
	anzeige.title = anzeige.innerText;
	anzeige.style.color = istStandard ? 'var(--primary-color)' : '';
}

/**
 * Öffnet den Dialog für den allgemeinen Absendernamen der Emails.
 * Gespeichert wird ohne Debounce, damit Keycloak direkt benachrichtigt werden kann.
 */
async function editEmailAbsenderName() {
	const einstellungen = await stammdatenService.getEmailAbsenderName();
	const input = document.getElementById('email-absender-name');
	input.value = einstellungen.AbsenderName;
	const result = await SystemDialogService.instance.displayAsync('email-absender-dialog');
	if (!result.success) {
		return;
	}
	const erfolg = await stammdatenService.updateEmailAbsenderName(input.value.trim());
	if (erfolg) {
		await ladeEmailEinstellungen();
	}
}

/**
 * Schließt den Absendername Dialog mit Übernahme der Eingabe.
 */
function confirmEmailAbsenderName() {
	SystemDialogService.instance.confirm();
}

// Aktuell im Dialog geöffnete Editor-Instanz und die normalisierte Standard-Markdown-Baseline.
// Über die Baseline erkennen wir beim Speichern, ob der Text (noch) dem Standard entspricht.
let willkommensEmailEditor = null;
let willkommensStandardBaseline = null;

/**
 * Öffnet einen Editor Dialog, um Betreff und Text (mit Formatierung) der Willkommensmail zu bearbeiten.
 * Falls noch kein individueller Text hinterlegt ist, wird der Standardtext vorbelegt.
 */
async function editWillkommensEmail() {
	const unternehmen = await stammdatenService.holeUnternehmensdaten();
	const willkommen = unternehmen.WillkommensEmail || {};
	const betreffInput = document.getElementById('willkommens-email-betreff');
	betreffInput.value = _.isEmpty(willkommen.Betreff) ? MitarbeiterAppInstallationEmail.Betreff : willkommen.Betreff;
	const istStandard = _.isEmpty(willkommen.HTML);
	const initialMarkdown = _.isEmpty(willkommen.Inhalt) ? MitarbeiterAppInstallationEmail.Inhalt : willkommen.Inhalt;
	// Editor wird erst bei Bedarf geladen (toast-ui ist ein großes Modul)
	const { createMarkdownEditor } = await import('../services/editorService.js');
	const resultPromise = SystemDialogService.instance.displayAsync('willkommens-email-dialog');
	const editor = createMarkdownEditor(document.querySelector('#willkommens-email-editor'), initialMarkdown, 'Willkommenstext eingeben...');
	willkommensEmailEditor = editor;
	// Beim Öffnen im Standard: normalisierte Baseline merken (Editor kann Markdown umformatieren)
	willkommensStandardBaseline = istStandard ? editor.getMarkdown() : null;
	const input = await resultPromise;
	const markdown = editor.getMarkdown();
	const html = editor.getHTML();
	// Entspricht der Text unverändert dem Standard, leeres HTML speichern -> Versand nutzt das Standard-Template (mit Links)
	const bleibtStandard = willkommensStandardBaseline !== null
		&& markdown === willkommensStandardBaseline
		&& betreffInput.value === MitarbeiterAppInstallationEmail.Betreff;
	editor.destroy();
	willkommensEmailEditor = null;
	willkommensStandardBaseline = null;
	if (!input.success) {
		return;
	}
	unternehmen.WillkommensEmail = {
		Betreff: betreffInput.value,
		Inhalt: markdown,
		HTML: bleibtStandard ? '' : html,
	};
	updateDebounceUnternehmen(unternehmen);
}

/**
 * Schließt den Willkommensmail Dialog mit Übernahme der Eingabe.
 */
function confirmWillkommensEmail() {
	SystemDialogService.instance.confirm();
}

/**
 * Befüllt Betreff und Editor im offenen Dialog wieder mit dem neolohn-Standard.
 * Der Dialog bleibt offen; gespeichert wird erst über "Speichern".
 */
function resetWillkommensEmail() {
	if (!willkommensEmailEditor) {
		return;
	}
	document.getElementById('willkommens-email-betreff').value = MitarbeiterAppInstallationEmail.Betreff;
	willkommensEmailEditor.setMarkdown(MitarbeiterAppInstallationEmail.Inhalt);
	// Baseline neu setzen, damit beim Speichern wieder das Standard-Template (mit Links) greift
	willkommensStandardBaseline = willkommensEmailEditor.getMarkdown();
	systemNachrichtService.zeigeKleineNachricht('Auf Standard zurückgesetzt. Zum Übernehmen "Speichern" drücken.', 0);
}

/**
 * Lädt die hinterlegten Anhänge der Willkommensmail und zeigt sie an.
 */
async function ladeWillkommensAnhaenge() {
	const liste = document.getElementById('willkommens-anhaenge-liste');
	if (!liste) {
		return;
	}
	liste.innerHTML = '';
	const anhaenge = await stammdatenService.getWillkommensAnhaenge();
	if (_.isEmpty(anhaenge)) {
		const leer = document.createElement('div');
		leer.style.color = 'var(--primary-color)';
		leer.style.fontSize = '12px';
		leer.innerText = 'Keine Anhänge';
		liste.appendChild(leer);
		return;
	}
	anhaenge.forEach((anhang) => {
		const zeile = document.createElement('div');
		zeile.className = 'fieldset-div u-verzeichnis-zeile';
		const name = document.createElement('span');
		name.innerText = anhang.Name;
		name.title = anhang.Name;
		name.style.overflow = 'hidden';
		name.style.textOverflow = 'ellipsis';
		name.style.whiteSpace = 'nowrap';
		const deleteButton = document.createElement('button');
		deleteButton.type = 'button';
		deleteButton.className = 'entfernen-button';
		deleteButton.title = 'Anhang löschen';
		deleteButton.innerHTML = '<i class="bi bi-trash-fill" style="font-size: 14px;"></i>';
		deleteButton.onclick = () => entferneWillkommensAnhang(anhang._id);
		zeile.appendChild(name);
		zeile.appendChild(deleteButton);
		liste.appendChild(zeile);
	});
}

/**
 * Event Handler für das Hochladen von Willkommensmail-Anhängen.
 * @param {HTMLElement} thisElement file input Element
 */
async function uploadWillkommensAnhaenge(thisElement) {
	const inputForm = thisElement.closest('form');
	const formData = new FormData(inputForm);
	const allowedFormats = ['application/pdf', 'image/png', 'image/jpg', 'image/jpeg', 'image/tiff'];
	const files = formData.getAll('file-upload');
	if (files.some((file) => !allowedFormats.includes(file.type))) {
		systemNachrichtService.zeigeKleineNachricht('Nur PDF-, .png-, .jpg- und .tiff-Dateien sind erlaubt!');
		thisElement.value = '';
		return;
	}
	const result = await stammdatenService.postWillkommensAnhaenge(formData);
	thisElement.value = '';
	if (result) {
		await ladeWillkommensAnhaenge();
	}
}

/**
 * Entfernt einen Anhang der Willkommensmail.
 * @param {string} anhangID
 */
async function entferneWillkommensAnhang(anhangID) {
	const result = await stammdatenService.deleteWillkommensAnhang(anhangID);
	if (result) {
		await ladeWillkommensAnhaenge();
	}
}

/**
 * Sendet die Anfrage an des Server, das ausgewählte Verzeichnis freizugeben (oder die Freigabe zu widerrufen).
 * - Gibt alle im Verzeichnis unterliegenden Dateien frei, bzw. nicht mehr frei
 * @param {HTMLElement} thisElement input[type=checkbox]
 */
async function freigabeVerzeichnis(thisElement) {
    const verzeichnisID = _.last(thisElement.closest('.u-verzeichnis-zeile').id.split('-'));
    try {
        const response = await fetch('/neolohn/api/verzeichnis/freigeben', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                VerzeichnisID: verzeichnisID,
            })
        });
        if (!response.ok) {
			const msg = await response.text();
			systemNachrichtService.zeigeKleineNachricht(msg);
			throw new Error(`HTTP error, status = ${response.status}`);
		}
		systemNachrichtService.zeigeKleineNachricht('Verzeichnisfreigabe aktualisiert!', 1);
		await stammdatenService.holeUnternehmensdaten(true);
    } catch (error) {
        console.log(error);
        systemNachrichtService.zeigeKleineNachricht('Aktualisierung fehlgeschlagen!', -1);
    }
}

export {
    ladeAlleEinstellungen
};
